export function getInitials(name: string, maxLength: number = 2): string {
  return name
    .trim()
    .split(" ")
    .filter((word) => word.length > 0)
    .slice(0, maxLength)
    .map((word) => word.charAt(0))
    .join("")
    .toUpperCase();
}

export function getSchoolInitials(schoolName: string): string {
  return getInitials(schoolName, 2);
}

export function getDistrictInitials(districtName: string): string {
  return getInitials(districtName, 5);
}
